import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../classes/product.class';

@Component({
  selector: 'app-product-photo',
  templateUrl: './product-photo.component.html',
  styleUrls: ['./product-photo.component.css']
})
export class ProductPhotoComponent implements OnInit {

  @Input() product: Product;

  constructor() { }

  ngOnInit() {
  }

}
